import { getBoundedValue } from 'utils/math/math.utils';

const DEFAULT_FRAME_INTERVAL_MINUTES = 10;
const MIN_PLAYBACK_SPEED = 0.1;

export function normalizeIntervalMinutes(
  intervalMinutes,
  fallback = DEFAULT_FRAME_INTERVAL_MINUTES,
) {
  return Number.isFinite(intervalMinutes) && intervalMinutes > 0 ? intervalMinutes : fallback;
}

export function getIntervalMs(intervalMinutes = DEFAULT_FRAME_INTERVAL_MINUTES) {
  return normalizeIntervalMinutes(intervalMinutes) * 60 * 1000;
}

export function roundToNearestIntervalMinutes(
  date,
  intervalMinutes = DEFAULT_FRAME_INTERVAL_MINUTES,
) {
  const intervalMs = getIntervalMs(intervalMinutes);
  return new Date(Math.round(date.getTime() / intervalMs) * intervalMs);
}

export function generateFrameTimes(
  baseTime,
  frameCount = 12,
  intervalMinutes = DEFAULT_FRAME_INTERVAL_MINUTES,
  historyFrameCount = 0,
) {
  const frameIntervalMs = getIntervalMs(intervalMinutes);
  const baseTimeMs = baseTime.getTime();

  return Array.from(
    { length: frameCount },
    (_, frameIndex) => new Date(baseTimeMs + (frameIndex - historyFrameCount) * frameIntervalMs),
  );
}

export function getPlaybackFrameIntervalMs(
  playbackSpeed,
  { playbackIntervalBySpeed, basePlaybackIntervalMs, minPlaybackIntervalMs, maxPlaybackIntervalMs },
) {
  const configuredInterval = playbackIntervalBySpeed?.[playbackSpeed];

  if (Number.isFinite(configuredInterval)) {
    return configuredInterval;
  }

  return getBoundedValue(
    basePlaybackIntervalMs / Math.max(playbackSpeed, MIN_PLAYBACK_SPEED),
    minPlaybackIntervalMs,
    maxPlaybackIntervalMs,
  );
}
